import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles<boolean>()((theme, hasError) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(0.5),
        transition: theme.transitions.create("height", {
            duration: theme.transitions.duration.shorter,
        }),
    },
    border: {
        boxShadow: `0 0 0 2px ${hasError ? theme.palette.background.paper : theme.palette.primary.main}`,
        border: `2px solid ${theme.palette.primary.main}`,
        borderRadius: `14px`,
    },
    reason: {
        color: theme.palette.secondary.main,
    },
    errorMessage: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        opacity: 0,
        height: 0,
        overflow: "hidden",
        transform: `translateY(-${theme.spacing(3)})`,
        transition: theme.transitions.create("opacity, transform", {
            duration: theme.transitions.duration.shorter,
        }),
        ...(hasError && {
            height: "auto",
            opacity: 1,
            transform: "translateY(0px)",
        }),
        "&.visible": {
            height: "auto",
            opacity: 1,
            transform: "translateY(0px)",
        },
    },
}));
